import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import starRating from '../../../../images/redStarRating.svg';
import pcheart from '../../../../images/esso-red-heart.svg';

export const Section = styled.div`
  &.rating-banner {
    padding-top: 40px;
    padding-bottom: 40px;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      padding-top: 70px;
      padding-bottom: 70px;
    }
  }
`;

export const Heading = styled.h2`
  margin: auto;
  max-width: 1200px;
  text-align: center;
  width: calc(100% - ${themeGet('media.grid-gutter.2')});
  padding-bottom: 1.75rem;
  p.pc-heart {
    line-height: normal;
    &:after {
      display: inline-block;
      position: relative;
      content: '';
      top: 1rem;
      width: 2.25rem;
      height: 3.15rem;
      margin-left: 0.5rem;
      background-image: url(${pcheart});
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
    }
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
    padding-bottom: 2.75rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }
`;

export const Banner = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.75rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1.5rem;
  }

  &.rating-and-testimonial {
    margin-bottom: -2.25rem;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      margin-bottom: -2.875rem;
    }

    @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
      margin-bottom: -3.5rem;
    }
  }
`;

export const RatingWrapper = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  text-align: center;
  width: calc(100% / 3 - 0.375rem);
  gap: 0.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  padding: 1.5rem 0;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% / 3 - 0.75rem);
  }
`;

export const Subtext = styled.p`
  font-size: 1rem;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 1.125rem;
  }
`;

export const StarRating = styled.div`
  font-size: 1.375rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: normal;
  color: ${themeGet('colors.esso-red')};
  &:after {
    display: inline-block;
    position: relative;
    content: '';
    height: 1.375rem;
    width: 1.375rem;
    top: 3px;
    margin-left: 0.5rem;
    background-image: url(${starRating});
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.25rem;

    &:after {
      height: 2.25rem;
      width: 2.25rem;
      top: 3px;
    }
  }
`;

export const UserCounts = styled.div`
  font-size: 1.375rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: normal;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 2.25rem;
  }
`;
